import React from 'react'
import { Repeat } from 'lucide-react'

export interface RecurringEventBadgeProps {
  size?: 'sm' | 'md' | 'lg'
  showLabel?: boolean
  className?: string
}

/**
 * RecurringEventBadge Component
 *
 * Displays a visual indicator for recurring events with a chain/repeat icon.
 * Can be used in calendar views to distinguish recurring events from single events.
 */
export default function RecurringEventBadge({
  size = 'sm',
  showLabel = false,
  className = ''
}: RecurringEventBadgeProps) {
  const sizeClasses = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  }

  const iconSize = {
    sm: 10,
    md: 12,
    lg: 16
  }

  return (
    <div
      className={`inline-flex items-center gap-1 ${className}`}
      title="Evento recorrente"
      aria-label="Evento recorrente"
    >
      <div className={`flex items-center justify-center rounded-full bg-brand-primary/20 ${sizeClasses[size]}`}>
        <Repeat size={iconSize[size]} className="text-brand-primary" />
      </div>
      {showLabel && (
        <span className="text-xs text-brand-primary font-medium">
          Recorrente
        </span>
      )}
    </div>
  )
}
